export default __webpack_public_path__ + "static/media/popup.35edc1ed.svg";